export function coalesce<T>(value: T | null | undefined, defaultValue: T): T {
  if (value === null || value === undefined)
    return defaultValue;
  return value;
}
